import type { FC, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import type { DataCyProp } from '@/types';
import { TypographyType } from '../enums/type';
import type { StaticOptions } from '../types/StaticOptions';

export interface AssistiveMessageProps extends DataCyProp {
  type?: TypographyType.Secondary | TypographyType.Error;
  /**
   * When used in static context, staticOptions must be provided to the component
   *  */
  staticOptions?: StaticOptions;
}

export const StyledLabel = styled.span<Pick<AssistiveMessageProps, 'type'>>`
  margin: 0;

  ${({ theme }) => theme.typography.configurations.assistiveMessage}

  ${({ type, theme }) => css`
    color: ${
      type === TypographyType.Secondary ? theme.color.semantic.type.secondary : theme.color.semantic.feedback.type.error
    };
  `}
`;

export const AssistiveMessage: FC<PropsWithChildren<AssistiveMessageProps>> = ({
  children,
  type = TypographyType.Secondary,
  staticOptions,
  'data-cy': dataCy,
}) => {
  const { theme } = staticOptions ?? {};
  return (
    <StyledLabel data-cy={dataCy} theme={theme} type={type}>
      {children}
    </StyledLabel>
  );
};
